import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {

  constructor(private http: HttpClient) { }

  public parentInitEvent: EventEmitter<void> = new EventEmitter<void>();
  getTeamDetails(): Observable<any> {
    const url = environment.apiURL + `api/creatics/team/list`;
    return this.http.get(url);
  }
}
